import React, { useState } from "react";
import { connect } from "react-redux";
import { addLoyaltyReward, syncLoyaltyRewards } from "../../actions/loyalty.js";
import { getMenu } from "../../actions/menu.js";
import Coupon from "./forms/Coupon";
import Discount from "./forms/Discount";
import FreeDelivery from "./forms/FreeDelivery";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle.jsx";

function camelize(str) {
	return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
		if (+match === 0) return "";
		return index === 0 ? match.toLowerCase() : match.toUpperCase();
	});
}

const AddLoyaltyRewards = ({ addLoyaltyReward, syncLoyaltyRewards, getMenu, menu }) => {
	const [type, setType] = useState("");

	const onSubmit = (data) => {
		let formData = { ...data, type: camelize(type) };

		if (formData.amount) formData = { ...formData, amount: Number(data.amount) };
		if (type === "discount") {
			const itemDetails = menu.find((item) => item._id === data.itemDetails);
			if (itemDetails.price && formData.amount > itemDetails.price) {
				alert("Hay un error en la cantidad, debe ser mayor a 0 y menor al precio del producto");
				return;
			}
			formData = { ...formData, itemDetails };
		}
		addLoyaltyReward(formData, syncLoyaltyRewards);
		setType("");
	};

	const formSelector = (
		<>
			<ButtonWithStyle onClick={() => setType("discount")}>Descuento de Menu</ButtonWithStyle>
			<ButtonWithStyle onClick={() => setType("coupon")}>Cupon de Descuento</ButtonWithStyle>
			<ButtonWithStyle onClick={() => setType("freeDelivery")}>Descuento en Envio</ButtonWithStyle>
		</>
	);
	const formSwitch = () => {
		switch (type) {
			case "coupon":
				return <Coupon onSubmit={onSubmit} onCancel={() => setType("")} />;
			case "discount":
				return <Discount menuItems={menu} updateMenu={getMenu} onSubmit={onSubmit} onCancel={() => setType("")} />;
			case "freeDelivery":
				return <FreeDelivery onSubmit={onSubmit} onCancel={() => setType("")} />;

			default:
				return formSelector;
		}
	};

	return (
		<div>
			<hr />
			<h3>
				{type ? "Si regresa antes de terminar, no se guardará la información" : "Elija un tipo de premio a agregar"}
			</h3>
			{formSwitch()}
		</div>
	);
};

const mapStateToProps = ({ menu }) => {
	return { menu };
};
export default connect(mapStateToProps, { syncLoyaltyRewards, addLoyaltyReward, getMenu })(AddLoyaltyRewards);
